<template>
	<div
		class="right check_col check_col2 m_toggle"
		v-bind:class="{
			col_done: done,
			col_disable: this.$store.state.checkoutStage === 'info'
		}"
	>
		<h2 class="check_title" onclick="mobileToggle(this)">
			פרטי משלוח
			<SHIPP />
			<span class="ok-svg">
				<OK />
			</span>
			<span class="check_col_plus"></span>
		</h2>
		<div class="check_col_inner m_toggleInner">
			<div class="group fields_open" v-bind:class="{ hide: !showOpenEdits }">
				<div class="title_s">מתי נוח לך שנגיע?</div>
				<div class="text">
					זמני האספקה המוצגים הינם לפי איזור החלוקה וזמני המשלוח הפנויים בעת שליחת ההזמנה. ניתן לקבל טווח זמן
					מדויק יותר של עד שעתיים, בסמוך למועד יציאת המשלוח כמפורט בסעיף 3.4 ב
					<a :href="terms_page" target="_blank">תקנון האתר</a>
				</div>
				<div class="shipp_times">
					<div class="error_tx">עליך לבחור יום וטווח שעות למשלוח</div>
					<div v-if="!permenent">
						<div class="slotsLoader" v-if="!slotsLoaded">
							<span>שניה.. כבר נציג לך את זמני המשלוח</span>
							<img :src="loaderSVGreen" alt="" />
						</div>
						<div
							class="shipp_time_row clearfix"
							v-for="shippingTime in shippingTimes"
							:key="shippingTime.date"
						>
							<div class="right shipp_time_col1">
								{{ shippingTime.day }}
							</div>
							<div class="right shipp_time_col2">
								<div
									class="right shipp_time_hour ease"
									v-for="shippingHour in shippingTime.hours"
									v-bind:class="{
										active: isHourSelected(shipmentTime, shippingHour)
									}"
									:key="shippingHour.id"
								>
									<a
										href="javascript:void(0);"
										@click="
											selectHour(
												$event,
												shippingHour.id,
												shippingTime.date,
												shippingHour.employee_number
											)
										"
										>{{ shippingHour.hour }}</a
									>
								</div>
							</div>
						</div>
						<div
							class="shipp_time_row clearfix"
							v-if="selectedFar.length > 0"
							v-for="(shippingTime, index) in selectedFar"
							:key="index"
						>
							<div class="right shipp_time_col1">
								{{ shippingTime.day }}
							</div>
							<div class="right shipp_time_col2">
								<div
									class="right shipp_time_hour ease"
									v-for="shippingHour in shippingTime.hours"
									v-bind:class="{
										active: isHourSelected(shipmentTime, shippingHour)
									}"
									:key="shippingHour.id"
								>
									<a
										href="javascript:void(0);"
										@click="
											selectHour(
												$event,
												shippingHour.id,
												shippingTime.date,
												shippingHour.employee_number
											)
										"
										>{{ shippingHour.hour }}</a
									>
								</div>
							</div>
						</div>
					</div>
					<div class="slotsLoader" v-if="!slotsLoaded">
						<span>שניה.. כבר נציג לך את זמני המשלוח</span>
						<img :src="loaderSVGreen" alt="" />
					</div>
					<div
						class="shipp_time_row clearfix"
						v-for="(shippingTime, index) in permenentShippingTimes"
						v-if="permenent"
						:key="index"
					>
						<div class="right shipp_time_col1">
							{{ shippingTime.day }}
						</div>

						<div class="right shipp_time_col2">
							<div
								class="right shipp_time_hour ease"
								v-for="shippingHour in shippingTime.hours"
								:data-hourid="shippingHour.id"
								:data-slotindex="shippingTime.date"
								:data-employeenumber="shippingHour.employee_number"
								:class="{
									active: isHourSelected(shippingTime, shippingHour)
								}"
								:key="shippingHour.id"
							>
								<a
									href="javascript:void(0);"
									@click="selectHour($event, shippingHour.id, index, shippingHour.employee_number)"
									>{{ shippingHour.hour }}</a
								>
							</div>
						</div>

						<div
							class="shipp_time_row clearfix"
							v-if="selectedFar.length > 0"
							v-for="(shippingTime, index) in selectedFar"
							:key="index"
						>
							<div class="right shipp_time_col1">
								{{ shippingTime.day }}
							</div>
							<div class="right shipp_time_col2">
								<div
									class="right shipp_time_hour ease"
									v-for="shippingHour in shippingTime.hours"
									:data-hourid="shippingHour.id"
									:data-slotindex="shippingTime.date"
									:data-employeenumber="shippingTime.date"
									v-bind:class="{
										active: isHourSelected(shipmentTime, shippingHour)
									}"
									:key="shippingHour.id"
								>
									<a
										href="javascript:void(0);"
										@click="
											selectHour(
												$event,
												shippingHour.id,
												shippingTime.date,
												shippingHour.employee_number
											)
										"
										>{{ shippingHour.hour }}</a
									>
								</div>
							</div>
						</div>
					</div>
					<input type="hidden" v-validate="'required'" name="ship_time" v-bind:value="jsonShip" />
				</div>
				<div class="green_link" v-if="!permenent">
					<a href="javascript:void(0);" @click="openHours()">הצג זמני משלוח נוספים &nbsp;></a>
				</div>
				<div class="error_tx" v-if="showError">{{ timeErrorMsg }}</div>
			</div>
			<div class="group fields_close" v-if="!showOpenEdits">
				<div class="title_s relative">
					זמן משלוח
					<a href="javascript:void(0)" @click="toggleEditInputs" class="edit_link">
						ערוך פרטים
						<PEN />
					</a>
				</div>
				<div class="text" v-html="shipmentTime"></div>
				<hr />
			</div>
			<div class="group fields_open" v-bind:class="{ hide: !showOpenEdits }">
				<div class="radio_row clearfix">
					<div class="right form_tx">
						אני רוצה מוצרים חלופיים
						<span class="red">*</span>
					</div>
					<div class="right wrap_tooltip">
						<div
							class="type_info hasTooltip"
							title="במקרה שאחד המוצרים שהזמנת חסר, האם לשים לך מוצר דומה במקומו?"
						>
							?
						</div>
					</div>
					<div class="right radio_choose">
						<label class="right form_check form_radio">
							<div class="form_check_tx">
								כן
								<input
									type="radio"
									name="order_alternateproducts"
									v-model="alternate"
									v-validate="'required'"
									value="כן"
								/>
								<span class="checkmark"></span>
							</div>
						</label>
						<label class="right form_check form_radio">
							<div class="form_check_tx">
								לא
								<input type="radio" name="order_alternateproducts" v-model="alternate" value="לא" />
								<span class="checkmark"></span>
							</div>
						</label>
					</div>
					<div class="error_tx right" v-if="errors.first('order_alternateproducts')">
						{{ errors.first("order_alternateproducts") }}
					</div>
				</div>
				<div class="clearfix">
					<label class="right form_check">
						<div class="form_check_tx">
							משלוח ללא שקיות ניילון
							<input type="checkbox" name="order_nobags" v-model="nobags" />
							<span class="checkmark"></span>
						</div>
					</label>
					<div class="right wrap_tooltip">
						<div
							class="type_info hasTooltip"
							title="איכות הסביבה חשובה לך?! ניתן לקבל משלוח עם כמה שפחות שקיות ניילון"
						>
							?
						</div>
					</div>
				</div>
			</div>
			<div class="group fields_close" v-if="!showOpenEdits">
				<div class="text" v-html="shipmentAltBags"></div>
				<hr />
			</div>
			<div
				class="group addnotes toggleContainer fields_open"
				v-bind:class="{ hide: !showOpenEdits, active: firstShowComments }"
			>
				<div class="top_addnote">
					<a href="javascript:void(0);" onclick="toggle(this);">
						<span class="title_s">הערות</span>
						<span class="top_addnote-plus">+ הוספת הערות</span>
						<span class="top_addnote-plus top_addnote-close">- סגירת הערות</span>
					</a>
				</div>
				<div class="bottom_addnote toggleInner" :style="{ display: firstShowComments ? 'block' : 'none' }">
					<div class="clearfix">
						<div class="form_tx">הערה כללית</div>
						<div class="form_input">
							<input type="text" name="order_comments" maxlength="90" v-model="order_comments" />
						</div>
					</div>
					<div class="clearfix">
						<div class="form_tx">הערה לשליח</div>
						<div class="form_input">
							<input
								type="text"
								name="order_comments2"
								maxlength="90"
								v-model="order_comments2"
								placeholder="למשל , להשאיר ליד הדלת..."
							/>
						</div>
					</div>
				</div>
			</div>
			<div class="group fields_close" v-if="!showOpenEdits && notes">
				<div class="title_s relative">
					הערות
					<a href="javascript:void(0)" @click="toggleEditInputs" class="edit_link">
						ערוך פרטים
						<PEN />
					</a>
				</div>
				<div class="text" v-html="notes"></div>
			</div>
			<div class="bt_green ease">
				<a href="javascript:void(0);" @click="changeTab('payment')">לסיכום ותשלום</a>
			</div>
		</div>
	</div>
</template>
<script>
	/** SVG import */
	import OK from "../../assets/img/ok.svg";
	import SHIPP from "../../assets/img/shipp.svg";
	import PEN from "../../assets/img/pen.svg";
	import { mapGetters, mapState } from "vuex";
	export default {
		data() {
			return {
				terms_page: wpData.terms_page,
				editInputs: true,
				loaderSVGreen: wpData.assets_url + "/svg/loader-green.svg",
				check: false,
				selectedHour: [],
				selectedDay: [],
				selectedFar: [],
				timeValid: false,
				showError: false,
				timeErrorMsg: "יש לבחור זמן משלוח.",
				loaded: false,
				firstLoad: false,
				firstShowComments: false,
				alternate: this.$store.getters.userCheckoutInfo.alter_products
					? this.$store.getters.userCheckoutInfo.alter_products == "1"
						? "כן"
						: "לא"
					: "לא",
				nobags:
					this.$store.getters.userCheckoutInfo.order_nobags == "1"
						? this.$store.getters.userCheckoutInfo.order_nobags
						: "",
				order_comments: "",
				order_comments2: this.$store.getters.userCheckoutInfo.order_comments2
					? this.$store.getters.userCheckoutInfo.order_comments2
					: ""
			};
		},
		watch: {
			selectedHour: function(id) {
				this.selectedDay = [];
				id.map(slot => {
					let selected = {
						date: slot.slotIndex,
						hour: "",
						day: "",
						id: slot.hourId,
						office_core_employee_number: slot.employee_number
					};

					if (typeof this.slots != "undefined" && this.slots && this.slots[slot.slotIndex]) {
						let find = Object.values(this.slots[slot.slotIndex].hours).find(
							hour => hour.id === slot.hourId
						);
						if (typeof find != "undefined") {
							const dayName = this.slots[slot.slotIndex].day;
							selected.hour = find.hour;
							selected.day = dayName;
							selected.date = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"].indexOf(dayName);
							this.selectedDay.push(selected);
							this.timeValid = true;
							this.showError = false;
						}
					}
				});
			}
		},
		computed: {
			...mapState(["orderEditMeta", "userLoggedInfo", "permenantOrderEdit"]),
			...mapGetters({ slots: "getSlots", orderEdit: "orderEdit" }),
			showOpenEdits() {
				if (!this.editInputs) {
					return false;
				}
				return true;
			},
			shipmentTime() {
				if (this.selectedDay.length > 0) {
					var html = "";
					this.selectedDay.map(day => {
						html = html + "יום " + day.day + " " + " בין השעות " + day.hour + "<br>";
					});
					return html;
				}
				return "";
			},
			shipmentAltBags() {
				let txt = "";
				if (this.alternate == "כן") {
					txt = "מאשר קבלת מוצרים חלופיים";
				} else {
					txt = "לא מאשר קבלת מוצרים חלופיים";
				}
				if (this.nobags) {
					txt = txt + "<br />משלוח ללא שקיות ניילון";
				}
				return txt;
			},
			notes() {
				let txt = "";
				if (this.order_comments) {
					txt = this.order_comments;
				}
				if (this.order_comments2) {
					if (txt) {
						txt = txt + "<br />";
					}
					txt = txt + this.order_comments2;
				}
				return txt;
			},
			done: {
				get() {
					if (this.$store.state.checkoutStage === "info") {
						this.check = false;
					}
					return this.check;
				},
				set(value) {
					this.check = true;
				}
			},
			jsonShip() {
				return JSON.stringify(this.selectedDay);
			},
			permenent() {
				if (this.$store.state.createPermenantOrder) {
					return true;
				}
				return false;
			},
			permenentEdit() {
				if (typeof this.$store.state.permenantOrderEdit == "object") {
					return true;
				}
				return false;
			},
			permenentShippingTimes() {
				return this.slots;
			},
			shippingTimes() {
				let s = Object.values(this.slots);
				return s.slice(0, 3);
			},

			shippingTimesForPop() {
				let s = Object.values(this.slots);
				return s.slice(3);
			},
			slotsLoaded() {
				if (!this.firstLoad && this.permenentEdit && this.slots && Object.keys(this.slots).length > 0) {
					this.selectedDay = [];
					this.selectedHour = [];
					this.$store.state.permenantOrderEdit.time.forEach((element, index) => {
						let time = {};
						if (typeof this.slots != "undefined" && this.slots && this.slots[parseInt(element.day) - 1]) {
							let find = this.slots[parseInt(element.day) - 1].hours.find(
								hour => hour.hour === element.time
							);
							if (typeof find != "undefined") {
								time = {
									hourId: find.id,
									slotIndex: parseInt(element.day) - 1
								};
							}
						}

						this.selectedHour.push(time);
					});

					this.firstLoad = true;
				}
				if (Object.keys(this.slots).length > 0) {
					return true;
				}
				return false;
			}
		},
		mounted() {
			var $this = this;
			if (this.order_comments || this.order_comments2) {
				this.firstShowComments = true;
			}
			this.$root.$on("removeOtherAddress", function(event) {
				$this.editInputs = true;
			});
		},
		methods: {
			toggleEditInputs() {
				this.editInputs = true;
				this.done = false;
				this.check = false;
				this.$store.commit("changeCheckoutStage", "shippment");
				this.$root.$emit("stage-complete", 1);
			},
			isHourSelected(day, hour) {
				const found = this.selectedHour.find(item => {
					return (
						item.hourId === hour.id &&
						item.slotIndex === day.date &&
						item.employee_number === hour.employee_number
					);
				});
				return typeof found === "object";
			},
			changeTab(tab) {
				this.$validator
					.validate()
					.then(result => {
						if (result && this.timeValid) {
							this.editInputs = false;
							this.done = true;
							this.$root.$emit("stage-complete", 2);
							this.$store.commit("changeCheckoutStage", tab);
							if (this.$mq == "mobile") {
								mobileToggle($(".check_col3 h2"));
							}
						}
						if (result && !this.timeValid) {
							this.showError = true;
						}
						if (!result && !this.timeValid) {
							this.showError = true;
						}
					})
					.catch(err => {});
			},
			selectHour(event, hourId, slot_index, employee_number) {
				this.selectedFar = [];
				let find = this.selectedHour.find(slot => slot.hourId == hourId && slot.slotIndex == slot_index);
				if (typeof find != "undefined") {
					let indexOfFound = this.selectedHour.indexOf(find);
					this.selectedHour.splice(indexOfFound, 1);
					return;
				}
				var tmp = { hourId: hourId, slotIndex: slot_index, employee_number: employee_number };
				this.selectedHour.push(tmp);
			}
		},
		components: {
			OK,
			SHIPP,
			PEN
		}
	};
</script>
